module.exports = "<p>\n  auto-auth works!\n</p>\n"